import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import { ContentMasteryFailureAttemptRateListService } from '../../services/ContentListService';
import { englishLevelCourses } from '../../../../../core/consts';
import { get } from 'lodash';
import ContentMasteryTestFailureAttemptRateTable from './ContentMasteryTestFailureAttemptRateTable';

class ContentMasteryTestFailureAttemptRateTableContainer extends React.Component {
  componentDidMount() {
    ContentMasteryFailureAttemptRateListService.load(
      this.props.masteryTestId ? 'masteryTest' : this.props.moduleId ? 'module' : 'course',
      this.props.masteryTestId || this.props.moduleId || this.props.courseId
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.masteryTestId !== prevProps.masteryTestId ||
      this.props.moduleId !== prevProps.moduleId ||
      this.props.courseId !== prevProps.courseId
    ) {
      ContentMasteryFailureAttemptRateListService.load(
        this.props.masteryTestId ? 'masteryTest' : this.props.moduleId ? 'module' : 'course',
        this.props.masteryTestId || this.props.moduleId || this.props.courseId
      );
    }
  }

  render() {
    return (
      <ContentMasteryTestFailureAttemptRateTable
        loading={
          ContentMasteryFailureAttemptRateListService.fetchCurrent.fetching ||
          ContentMasteryFailureAttemptRateListService.fetchPrevious.fetching
        }
        values={toJS(ContentMasteryFailureAttemptRateListService.getList()).map((item) =>
          Object.assign({}, item, {
            level: get(
              englishLevelCourses.find((c) => c.label === item.name),
              'value',
              null
            ),
          })
        )}
        nameColumnPath={this.props.courseId || this.props.moduleId || this.props.masteryId ? 'order' : 'level'}
        nameColumnRender={(row) => {
          if (this.props.masteryTestId) {
            return `${row.order} - ${row.type}`;
          } else if (this.props.moduleId) {
            return `${row.name}%`;
          } else if (this.props.courseId) {
            return `${row.order} - ${row.name}`;
          } else {
            return row.name;
          }
        }}
        onSelect={(row) => {
          if (this.props.masteryTestId) {
            return false;
          } else if (this.props.moduleId) {
            browserHistory.push(
              `/kpis/content/course/${this.props.courseId}/module/${this.props.moduleId}/mastery-test/${row.id}/mastery-details`
            );
          } else if (this.props.courseId) {
            browserHistory.push(`/kpis/content/course/${this.props.courseId}/module/${row.id}/mastery-details`);
          } else {
            browserHistory.push(`/kpis/content/course/${row.id}/mastery-details`);
          }
        }}
        formatter={ContentMasteryFailureAttemptRateListService.getFormattedValue}
        feedbackColorRender={ContentMasteryFailureAttemptRateListService.getFeedbackColor}
      />
    );
  }
}

ContentMasteryTestFailureAttemptRateTableContainer.propTypes = {
  courseId: PropTypes.string,
  moduleId: PropTypes.string,
  masteryTestId: PropTypes.string,
};

export default observer(ContentMasteryTestFailureAttemptRateTableContainer);
